import React from "react";
import {Navigation} from "../navigation.jsx";
import {Footer} from "../Footer";
import {Features} from "../features";
import {Services} from "../services";
import {useParams} from "react-router-dom";
import {Helmet} from "react-helmet";
import {GetText} from "../../data/lang";

export const DistributionPage = () => {

    const {lng} = useParams();
    let text = GetText();

    return (
        <div>
            <Helmet htmlAttributes={{ lang : lng }}>
                <title>MUK | {text.Distribution.title}</title>
                <meta name="description" content={text.Distribution.paragraph} />
                <meta name="keywords"  content='мук, muk, distribution, дистрибьюция' />
            </Helmet>
            <Navigation lng={lng}/>
            <div className="solution-detail menu-indent">
                <div className="solution-title">
                    <div className="container">
                        <h3>
                            {text.Distribution.title}
                        </h3>
                    </div>
                </div>
                {/*<div className="container">
                    <br/><br/>
                </div>*/}
            </div>
            <Features />
            <Services />
            <Footer/>
        </div>
    );
};
